module.exports = __webpack_public_path__ + "static/residential-demolition-d994c2d2d4fdbd31f2ec7e7a64e44cfa.jpg";